import { render, staticRenderFns } from "./DsaLoading.vue?vue&type=template&id=b5073eb8"
import script from "./DsaLoading.vue?vue&type=script&lang=js"
export * from "./DsaLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports